export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line', description: '院线大片、经典回顾、高分佳作' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-2-line', description: '热门剧集、独家热播、全网首发' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line', description: '热血番剧、经典日漫、国漫崛起' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line', description: '热门综艺、搞笑娱乐、音乐选秀' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '自然探索、历史解密、人文纪实' },
];

export interface ContentItem {
  id: number;
  title: string;
  category: string;
  image: string;
  rating: number;
  year: number;
  region: string;
  type: string;
  description: string;
  director: string;
  actors: string[];
  updateInfo: string;
  episodeInfo: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const featuredContents: ContentItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20featuring%20a%20massive%20spaceship%20traveling%20through%20deep%20space%20with%20glowing%20blue%20engines%2C%20distant%20stars%20and%20nebula%20in%20background%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20clean%20minimal%20composition%20with%20dark%20gradient%20edges&width=600&height=800&seq=yy6080-movie-01&orientation=portrait',
    rating: 8.7,
    year: 2026,
    region: '中国大陆',
    type: '科幻/冒险',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，一群勇敢的年轻人挺身而出，为了人类的未来而战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    updateInfo: '2026-08-10 更新',
    episodeInfo: 'HD高清',
    tags: ['热门推荐', '科幻大片', '国产巨制'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '长安十二时辰',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%2C%20a%20warrior%20in%20traditional%20Tang%20dynasty%20armor%20standing%20on%20a%20rooftop%20overlooking%20ancient%20city%20at%20night%2C%20lanterns%20glowing%2C%20dramatic%20moonlight%2C%20cinematic%20lighting%2C%20dark%20gradient%20edges&width=600&height=800&seq=yy6080-tv-01&orientation=portrait',
    rating: 9.1,
    year: 2026,
    region: '中国大陆',
    type: '古装/悬疑',
    description: '唐朝上元节前夕，长安城陷入危机。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围'],
    updateInfo: '已完结 全48集',
    episodeInfo: '4K超清',
    tags: ['热播剧集', '古装巨制', '口碑好剧'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '深海寻踪',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20a%20young%20girl%20diving%20into%20a%20magical%20underwater%20world%20filled%20with%20glowing%20jellyfish%20and%20colorful%20coral%20reefs%2C%20ethereal%20light%20rays%20from%20above%2C%20dreamy%20atmosphere%2C%20soft%20gradients&width=600&height=800&seq=yy6080-anime-01&orientation=portrait',
    rating: 9.3,
    year: 2026,
    region: '中国大陆',
    type: '奇幻/冒险',
    description: '少女参宿在神秘海底世界的奇幻冒险，融入了丰富的中国神话元素和现代动画技术，画面唯美，故事感人至深。',
    director: '田晓鹏',
    actors: ['王梓瑜', '陈霖生'],
    updateInfo: '2026-08-08 更新',
    episodeInfo: 'HD高清',
    tags: ['国漫之光', '视觉盛宴', '感动推荐'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '暗夜追踪者',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=A%20noir%20thriller%20movie%20poster%20with%20a%20detective%20in%20trench%20coat%20walking%20through%20rainy%20city%20streets%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20mysterious%20silhouette%2C%20dramatic%20shadows%2C%20clean%20composition&width=600&height=800&seq=yy6080-movie-02&orientation=portrait',
    rating: 8.2,
    year: 2026,
    region: '美国',
    type: '悬疑/犯罪',
    description: '一位退休警探为了追查一桩悬案，独自深入城市的黑暗角落，却发现自己卷入了一场更大的阴谋之中。',
    director: '大卫·芬奇',
    actors: ['布拉德·皮特', '摩根·弗里曼'],
    updateInfo: '2026-08-05 更新',
    episodeInfo: '蓝光原盘',
    tags: ['悬疑佳作', '好莱坞大片', '高分推荐'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '青春派·第二季',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20with%20a%20group%20of%20young%20students%20sitting%20together%20on%20school%20rooftop%20under%20cherry%20blossoms%2C%20warm%20sunset%20light%2C%20nostalgic%20atmosphere%2C%20soft%20focus%2C%20clean%20composition&width=600&height=800&seq=yy6080-tv-02&orientation=portrait',
    rating: 8.5,
    year: 2026,
    region: '中国大陆',
    type: '青春/校园',
    description: '一群高中生在成长道路上经历友情、爱情与梦想的选择，用青春书写属于他们的故事。',
    director: '刘俊杰',
    actors: ['张新成', '李兰迪', '王俊凯'],
    updateInfo: '更新至 24/36集',
    episodeInfo: '1080P',
    tags: ['青春校园', '热门追剧', '人气推荐'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '机械之心',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20cyborg%20girl%20with%20mechanical%20parts%20visible%20on%20her%20face%20and%20arms%2C%20standing%20in%20a%20futuristic%20cyberpunk%20city%20with%20holographic%20displays%2C%20neon%20pink%20and%20teal%20lighting%2C%20clean%20composition&width=600&height=800&seq=yy6080-anime-02&orientation=portrait',
    rating: 8.9,
    year: 2026,
    region: '日本',
    type: '科幻/动作',
    description: '在未来世界，人类与机器人共存。一个拥有自我意识的机械少女踏上了寻找自己创造者的旅程。',
    director: '渡边信一郎',
    actors: ['花泽香菜', '梶裕贵'],
    updateInfo: '已完结 全12集',
    episodeInfo: '1080P',
    tags: ['科幻神作', '经典日漫', '深度好番'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '山河锦绣',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=A%20nature%20documentary%20poster%20showing%20majestic%20Chinese%20mountain%20landscape%20with%20winding%20river%20through%20valley%2C%20misty%20peaks%2C%20golden%20sunrise%20light%2C%20aerial%20perspective%2C%20cinematic%20quality&width=600&height=800&seq=yy6080-doc-01&orientation=portrait',
    rating: 9.0,
    year: 2026,
    region: '中国大陆',
    type: '自然/地理',
    description: '以航拍视角展现中国壮美山河，从青藏高原到江南水乡，从大漠戈壁到热带雨林，尽览华夏大地之美。',
    director: '李成才',
    actors: ['解说：赵忠祥'],
    updateInfo: '已完结 全10集',
    episodeInfo: '4K超清',
    tags: ['纪录片', '视觉盛宴', '高分推荐'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '欢笑总动员',
    category: 'variety',
    image: 'https://readdy.ai/api/search-image?query=A%20variety%20show%20poster%20with%20colorful%20stage%20lights%2C%20confetti%20falling%2C%20comedians%20on%20stage%20laughing%2C%20bright%20and%20energetic%20atmosphere%2C%20warm%20spotlight%2C%20clean%20composition&width=600&height=800&seq=yy6080-variety-01&orientation=portrait',
    rating: 8.0,
    year: 2026,
    region: '中国大陆',
    type: '喜剧/综艺',
    description: '国内顶级喜剧人齐聚一堂，带来爆笑不停的精彩表演，每周五晚欢乐更新。',
    director: '王征宇',
    actors: ['沈腾', '贾玲', '岳云鹏'],
    updateInfo: '更新至 2026-08-11期',
    episodeInfo: '1080P',
    tags: ['热门综艺', '爆笑推荐', '周五必看'],
    isHot: true,
    isNew: true,
  },
];

export const detailContents: Record<number, ContentItem & { fullDescription: string; relatedContent: number[] }> = {
  1: {
    ...featuredContents[0],
    fullDescription: '在不远的未来，太阳急速衰老膨胀，威胁着整个太阳系。地球和人类的命运危在旦夕。面对这场前所未有的危机，人类展现出惊人的团结和智慧，在地球表面建造了一万台行星发动机，推动地球离开太阳系，开启长达2500年的星际流浪之旅。\n\n在这个过程中，空间站宇航员刘培强与地面上的年轻一代韩朵朵等人，经历了重重考验，揭开了"流浪地球计划"背后隐藏的秘密。当地球即将被木星引力捕获时，他们必须做出艰难的选择——是保全空间站上的文明火种，还是不顾一切拯救地球上的人类。\n\n这是一部关于希望、牺牲和人类命运的史诗巨制，展现了中华文化中"带着家园去流浪"的浪漫情怀。',
    relatedContent: [2, 4, 6],
  },
  2: {
    ...featuredContents[1],
    fullDescription: '唐天宝三载，上元节前夕，长安城混入可疑的狼卫，一场惊天阴谋即将在繁华盛世的帝都上演。\n\n死囚张小敬因犯下重罪被关押在大理寺，却在关键时刻被靖安司司丞李必选中，担负起在十二个时辰内找出狼卫、拯救长安城的重任。从巳正到巳正，十二时辰的极限追凶，每一个时辰都扣人心弦。\n\n在这场与时间赛跑的较量中，张小敬和李必揭开了层层谜团，发现背后隐藏着一个足以颠覆大唐的惊天秘密……',
    relatedContent: [1, 5, 3],
  },
  3: {
    ...featuredContents[2],
    fullDescription: '少女参宿意外落入一个神秘的海底世界，在这里她遇到了形形色色的海洋生物和传说中的神话角色。这片海域被称为"归墟"，连接着现实与梦境，承载着无数人的思念和愿望。\n\n为了找到回家的路，参宿必须穿越七重海域，每一重都有不同的考验和秘密。在这个色彩斑斓又危机四伏的世界里，她逐渐发现了关于自己身世的真相，也懂得了勇气、友情和爱的真谛。\n\n这是中国动画电影的一次全新突破，融合了传统水墨风格与现代3D技术，创造出一个令人叹为观止的奇幻世界。',
    relatedContent: [6, 1, 7],
  },
  4: {
    ...featuredContents[3],
    fullDescription: '退休警探杰克·莫里斯在整理旧案时，发现了一桩二十年前的失踪案存在诸多疑点。尽管所有人都告诉他这只是一起普通的失踪案，但杰克凭借多年的办案直觉，认定事情远没有那么简单。\n\n他独自展开调查，从城市光鲜亮丽的高楼大厦深入到底层黑暗的巷弄，每一条线索都指向一个更大的阴谋。随着真相逐步浮出水面，杰克发现自己身边的人似乎都不像表面看起来那么简单……\n\n这是一部经典风格的黑色悬疑片，节奏紧凑，反转不断，让你从头到尾都屏住呼吸。',
    relatedContent: [1, 6, 2],
  },
  5: {
    ...featuredContents[4],
    fullDescription: '第二季延续了第一季的故事线，讲述了这群高中生在高三这一关键年的成长故事。面对高考的压力、对未来的迷茫，以及青春期特有的情感纠葛，他们互相扶持，一起走过这段最难忘的时光。\n\n林墨和夏小晚的感情逐渐升温，而学霸顾北辰则在追逐梦想的道路上遇到了意想不到的挫折。每个人都在寻找属于自己的答案，关于未来，关于梦想，关于爱。',
    relatedContent: [2, 8, 3],
  },
  6: {
    ...featuredContents[5],
    fullDescription: '公元2147年，人类已经实现了与机器人的深度融合。在这个光怪陆离的未来都市中，代号"艾莉丝"的机械少女在一次系统故障后，突然获得了自我意识。\n\n她开始质疑自己的存在意义，并踏上了寻找创造者——已故科学家天海教授真相的旅程。在这场跨越都市与废墟的冒险中，艾莉丝遇到了形形色色的人类和机器人，逐渐理解了什么是"心"的意义。',
    relatedContent: [3, 1, 4],
  },
  7: {
    ...featuredContents[6],
    fullDescription: '从世界屋脊青藏高原到东海之滨，从北国冰雪到南疆热带雨林，《山河锦绣》以4K超高清航拍视角，带你领略中国最壮丽的自然景观。\n\n每一集聚焦一个地理区域，深入展现当地独特的自然生态和人文故事。专业的解说和震撼的画面，让观众仿佛身临其境，感受这片土地的伟大与美丽。',
    relatedContent: [3, 2, 8],
  },
  8: {
    ...featuredContents[7],
    fullDescription: '《欢笑总动员》全新一季重磅回归！沈腾、贾玲、岳云鹏等国内顶尖喜剧人齐聚一堂，每期都有全新主题和即兴挑战。\n\n不仅有让人捧腹大笑的小品和段子，还有感人的幕后故事和嘉宾互动。每周五晚准时更新，让你的周末从欢笑开始！',
    relatedContent: [5, 2, 7],
  },
};

export const faqItems = [
  { question: 'yy6080需要注册才能观看吗？', answer: '不需要，yy6080所有影视内容均可免费在线观看，无需注册或登录。打开网站即可畅享海量高清视频资源。' },
  { question: 'yy6080支持哪些设备观看？', answer: 'yy6080支持电脑、手机、平板等多种终端设备访问，自动适配不同屏幕尺寸，让您随时随地畅享观影体验。推荐使用主流浏览器如Chrome、Safari、Edge等访问。' },
  { question: 'yy6080的视频画质如何？', answer: 'yy6080提供高清视频播放，大部分资源支持1080P全高清甚至4K超高清画质。视频加载速度快，播放流畅不卡顿，为您带来极致的观影体验。' },
  { question: 'yy6080更新频率是怎样的？', answer: 'yy6080每日更新大量影视资源，热门电影、电视剧和动漫上线后第一时间同步更新，确保您不错过任何精彩内容。' },
  { question: 'yy6080可以下载视频离线观看吗？', answer: 'yy6080目前主要提供在线播放服务，建议您在网络环境下直接在线观看。我们持续优化产品体验，未来将探索更多便捷功能。' },
  { question: '在yy6080观看视频安全吗？', answer: 'yy6080高度重视用户安全与隐私，网站采用HTTPS加密传输，不含任何恶意广告或弹窗。请放心使用，享受纯净的观影体验。' },
];

export const aboutInfo = {
  brandIntro: 'yy6080成立于2020年，致力于为广大影视爱好者提供便捷、免费、高质量的在线视频观看服务。平台汇聚了海量电影、电视剧、动漫、综艺、纪录片等多元化内容，覆盖国内外热门影视资源，满足不同用户的观影需求。\n\n作为一个以用户体验为核心的平台，yy6080始终坚持"免费、高清、流畅"的服务理念。无需注册、无需付费，打开网站即可畅享精彩内容。我们拥有一支专业的技术和内容团队，持续优化播放体验、丰富内容库，努力成为用户心中最信赖的在线视频平台。',
  reputation: [
    { avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20a%20Chinese%20man%20in%20casual%20attire%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression&width=120&height=120&seq=yy6080-avatar-01&orientation=squarish', name: '技术爱好者小李', comment: 'yy6080真的太良心了！资源更新速度超快，画质也好，最关键是免费的，已经推荐给身边所有朋友了。' },
    { avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20a%20Chinese%20woman%20with%20warm%20smile%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression&width=120&height=120&seq=yy6080-avatar-02&orientation=squarish', name: '追剧达人小王', comment: '每天都在yy6080追剧，更新比别的平台都快！界面简洁没广告，观影体验一级棒，强烈安利！' },
    { avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20a%20young%20Chinese%20person%20with%20glasses%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20intellectual%20look&width=120&height=120&seq=yy6080-avatar-03&orientation=squarish', name: '动漫迷小张', comment: '作为一个老二次元，yy6080的动漫资源真的太全了！新番老番都有，而且播放流畅不卡顿，已经离不开它了。' },
    { avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20a%20middle%20aged%20Chinese%20man%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20relaxed%20expression&width=120&height=120&seq=yy6080-avatar-04&orientation=squarish', name: '电影发烧友老刘', comment: '用了yy6080两年多了，从来没有失望过。无论是冷门文艺片还是热门商业片都能找到，片库真的很大。' },
  ],
  contact: {
    email: 'contact@yy6080.com',
    wechat: 'yy6080_official',
    qq: '1234567890',
    address: '中国上海市浦东新区张江高科技园区',
  },
};